import React from 'react';
import { useAuthStore } from '../../../store/authStore';

const RoleGuard = ({ adminOnly = false, children }) => {
    const isAdmin = useAuthStore((s) => s.isAdmin);

    if (adminOnly && !isAdmin()) return null;
    return <>{children}</>;
};

export default RoleGuard;
